import styled from "styled-components";

import theme from "config/theme";

import StyledImage from "components/Image";

import { Block } from "components/Block/ContentBlock/styles";

export const HeadingBlock = styled(Block)`
  display: flex;
  flex-direction: column;
`;

export const Image = styled(StyledImage)`
  order: 2;
  display: block;
  width: 100%;
  margin: 100px 0 40px;
  width: 90%;

  @media (max-width: ${theme.size.desktop}) {
    margin-top: 80px;
    width: 100%;
  }

  @media (max-width: ${theme.size.tablet}) {
    order: 0;
    margin: 0 auto 30px;
    max-width: 400px;
  }

  @media (max-width: ${theme.size.mobile}) {
    max-width: 300px;
    margin: 0 auto 30px auto;
  }

  @media (max-width: 450px) {
    margin: 0 5px 30px auto;
  }
`;
